if(!customElements.get('compatibility-search')) {
    class CompatibilitySearch extends HTMLElement {
        constructor() {
            super();
            this.filterBagCache = [];
            this.emptyResult = false;
            this.manufacturerSelected = null;
            this.manufacturerHierarchy = null;
        }
        async connectedCallback() {
            this.jsonUrl = this.dataset.jsonUrl;
            await fetch(this.dataset.jsonUrl)
            .then(res => res.json())
            .then(data => {
                this.manufacturerHierarchy = data;
            })
            .catch(err => console.error('JSON load error:', err));
            this.selectors = {
                manufacture: this.querySelector('#select-manufacturer'),
                manufactureInput: this.querySelector('#select-manufacturer input'),
                manufactureClose: this.querySelector('#select-manufacturer button.close'),
                manufactureOptions: this.querySelector('#select-manufacturer-options'),
                printerModel: this.querySelector('#select-model'),
                printerModelInput: this.querySelector('#select-model input'),
                printerModelClose: this.querySelector('#select-model button.close'),
                printerModelOptions: this.querySelector('#select-model-options'),
                coreSize: this.querySelector('#select-core-size'),
                coreSizeInput: this.querySelector('#select-core-size input'),
                coreSizeClose: this.querySelector('#select-core-size button.close'),
                coreSizeOptions: this.querySelector('#select-core-size-options'),
                labelWidth: this.querySelector('#select-label-width'),
                labelWidthInput: this.querySelector('#select-label-width input'),
                labelWidthClose: this.querySelector('#select-label-width button.close'),
                labelWidthOptions: this.querySelector('#select-label-width-options'),
                labelHeight: this.querySelector('#select-label-height'),
                labelHeightInput: this.querySelector('#select-label-height input'),
                labelHeightClose: this.querySelector('#select-label-height button.close'),
                labelHeightOptions: this.querySelector('#select-label-height-options'),
                labelMaterial: this.querySelector('#select-label-material'),
                labelMaterialInput: this.querySelector('#select-label-material input'),
                labelMaterialClose: this.querySelector('#select-label-material button.close'),
                labelMaterialOptions: this.querySelector('#select-label-material-options'),
                labelGlueType: this.querySelector('#select-glue-type'),
                labelGlueTypeInput: this.querySelector('#select-glue-type input'),
                labelGlueTypeClose: this.querySelector('#select-glue-type button.close'),
                labelGlueTypeOptions: this.querySelector('#select-glue-type-options'),
                gridResult: document.querySelector('#grid-result'),
                rollUp: this.querySelector('#roll-up'),
                rollClose: this.querySelector('#roll-close'),
                search: this.querySelector('#open-search'),
                selectedFilters: this.querySelector('.selected-filters'),
                summaryFooter: this.querySelector('.summary-footer'),
                searchHero: document.querySelector('#ll-search-hero')
            }
            // Manufacture Event
            this.selectors.manufactureInput.addEventListener('focus', event => {
                event.target.closest('#select-manufacturer').classList.add('open');
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.manufactureInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-manufacturer').classList.add('open');
                const options = Array.from(this.selectors.manufactureOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.manufactureOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.manufactureOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.manufactureInput.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-manufacturer').classList.remove('open');
                    this.classList.remove('search');
                    this.classList.remove('return');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.manufactureOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-manufacturer').classList.remove('open');
                    this.classList.remove('search');
                    this.classList.remove('return');
                }
            });
            this.selectors.manufactureClose.addEventListener('click', () => {
                const options = this.selectors.manufactureOptions.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                this.selectors.manufacture.classList.remove('open');
                this.classList.remove('search');
                this.classList.remove('return');
            });            
            this.selectors.manufactureOptions.addEventListener('click', event => {
                this.filterBagCache = [];
                this.manufacturerSelected = event.target.closest('.option').dataset.value;
                this.filterBagCache.push(`${event.target.closest('.option').dataset.filtername}=${event.target.closest('.option').dataset.value}`);
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.printerModel.classList.remove('active','open');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.coreSize.classList.remove('active','open');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelWidth.classList.remove('active','open');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelHeight.classList.remove('active','open');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelMaterial.classList.remove('active','open');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelGlueType.classList.remove('active','open');
                this.selectors.manufactureInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;  
                this.fetchCollection('filter-p-m-spec-printer_model',this.selectors.printerModelOptions,this.selectors.printerModel);
                this.selectors.manufacture.classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            });
            // Printer Model Events
            this.selectors.printerModelInput.addEventListener('focus', event => {
                event.target.closest('#select-model').classList.add('open');
                this.classList.remove('return');
                this.classList.add('search');
            });
            this.selectors.printerModelInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-model').classList.add('open');
                const options = Array.from(this.selectors.printerModelOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.printerModelOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.printerModelOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.printerModelInput.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-model').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.printerModelOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-model').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.printerModelClose.addEventListener('click', event => {
                const options = this.selectors.printerModelOptions.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-model').classList.remove('open');
                this.classList.add('return');
                this.classList.add('search');
                
            });
            this.selectors.printerModelOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const existingIndex = this.filterBagCache.findIndex(
                    item => item.startsWith(`filter-p-m-spec-core_size=`)
                )
                if (existingIndex !== -1) {
                    this.filterBagCache.splice(existingIndex, 1);
                }
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.printerModelInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('filter-p-m-spec-core_size', this.selectors.coreSizeOptions, this.selectors.coreSize);
                this.selectors.printerModel.classList.remove('open');
                this.classList.add('return');
                this.classList.add('search');
            })
            // Printer Core Size Events
            this.selectors.coreSizeInput.addEventListener('focus', event => {
                event.target.closest('#select-core-size').classList.add('open');
                this.classList.remove('return');
                this.classList.add('search');
            });
            this.selectors.coreSizeInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-core-size').classList.add('open');
                const options = Array.from(this.selectors.coreSizeOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.coreSizeOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.coreSizeOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.coreSizeInput.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-core-size').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.coreSizeOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-core-size').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.coreSizeClose.addEventListener('click', event => {
                const options = this.selectors.coreSizeOptions.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-core-size').classList.remove('open');
                this.classList.add('return');
                this.classList.add('search');
            });
            this.selectors.coreSizeOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const existingIndex = this.filterBagCache.findIndex(
                    item => item.startsWith(`filter.p.m.spec.label_width=`)
                )
                if (existingIndex !== -1) {
                    this.filterBagCache.splice(existingIndex, 1);
                }
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.coreSizeInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('filter-p-m-spec-label_width', this.selectors.labelWidthOptions, this.selectors.labelWidth);
                this.selectors.coreSize.classList.remove('open');
                this.classList.add('return');
                this.classList.add('search');
            })
            // Label Width Events
            this.selectors.labelWidthInput.addEventListener('focus', event => {
                event.target.closest('#select-label-width').classList.add('open');
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelWidthInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-label-width').classList.add('open');
                const options = Array.from(this.selectors.labelWidthOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.labelWidthOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.labelWidthOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelWidthOptions.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-label-width').classList.remove('open');
                    this.classList.add('search');
                    this.classList.add('return');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.labelGlueTypeOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-label-width').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.labelWidthClose.addEventListener('click', event => {
                const options = this.selectors.labelWidthOptions.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-label-width').classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            });
            this.selectors.labelWidthOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const existingIndex = this.filterBagCache.findIndex(
                    item => item.startsWith(`filter-p-m-spec-label_height=`)
                )
                if (existingIndex !== -1) {
                    this.filterBagCache.splice(existingIndex, 1);
                }
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelWidthInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('filter-p-m-spec-label_height', this.selectors.labelHeightOptions,this.selectors.labelHeight);
                this.selectors.labelWidth.classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            })  
            // Label Height events
            this.selectors.labelHeightInput.addEventListener('focus', event => {
                event.target.closest('#select-label-height').classList.add('open');
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelHeightInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-label-height').classList.add('open');
                const options = Array.from(this.selectors.labelHeightOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.labelHeightOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.labelHeightOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelHeightOptions.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-label-height').classList.remove('open');
                    this.classList.add('search');
                    this.classList.add('return');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.labelHeightOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-label-height').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.labelHeightClose.addEventListener('click', event => {
                const options = this.selectors.labelHeightOptions.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-label-height').classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            });
            this.selectors.labelHeightOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const existingIndex = this.filterBagCache.findIndex(
                    item => item.startsWith(`filter-p-m-spec-label_material=`)
                )
                if (existingIndex !== -1) {
                    this.filterBagCache.splice(existingIndex, 1);
                }
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelHeightInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('filter-p-m-spec-label_material', this.selectors.labelMaterialOptions,this.selectors.labelMaterial);
                this.selectors.labelHeight.classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            })
            //Label Material Events
            this.selectors.labelMaterialInput.addEventListener('focus', event => {
                event.target.closest('#select-label-material').classList.add('open');
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelMaterialInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-label-material').classList.add('open');
                const options = Array.from(this.selectors.labelMaterialOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.labelMaterialOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.labelMaterialOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelMaterialOptions.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-label-material').classList.remove('open');
                    this.classList.add('search');
                    this.classList.add('return');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.labelMaterialOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-label-material').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.labelMaterialClose.addEventListener('click', event => {
                const options = this.selectors.labelMaterialClose.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-label-material').classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            });
            this.selectors.labelMaterialOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const existingIndex = this.filterBagCache.findIndex(
                    item => item.startsWith(`filter-p-m-custom-glue_type=`)
                )
                if (existingIndex !== -1) {
                    this.filterBagCache.splice(existingIndex, 1);
                }
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelMaterialInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('filter-p-m-spec-label_adhesive', this.selectors.labelGlueTypeOptions,this.selectors.labelGlueType);
                this.selectors.labelMaterial.classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            })
            // Glue Type Events
            this.selectors.labelGlueTypeInput.addEventListener('focus', event => {
                event.target.closest('#select-glue-type').classList.add('open');
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelGlueTypeInput.addEventListener('input', event => {
                event.target.value.length > 0 && event.target.closest('#select-glue-type').classList.add('open');
                const options = Array.from(this.selectors.labelMaterialOptions.children);
                const value = event.target.value.toLowerCase();
                const sorted = options.slice().sort((a,b) => {
                    const textA = a.textContent.toLowerCase();
                    const textB = b.textContent.toLowerCase();

                    const aStarts = textA.startsWith(value);
                    const bStarts = textB.startsWith(value);

                    if(aStarts && !bStarts) return -1;
                    if(!aStarts && bStarts) return 1;
                    return textA.localeCompare(textB);
                });
                this.selectors.labelGlueTypeOptions.innerHTML = '';
                sorted.forEach(el => this.selectors.labelGlueTypeOptions.append(el));
                this.classList.add('search');
                this.classList.remove('return');
            });
            this.selectors.labelGlueTypeOptions.addEventListener('keydown', event => {
                if(event.key === 'Escape') {
                    event.target.closest('#select-glue-type').classList.remove('open');
                    this.classList.add('search');
                    this.classList.add('return');
                };
                if(event.key === 'Enter') {
                    const options = this.selectors.labelGlueTypeOptions.querySelectorAll('.option');
                    options.length > 0 && options[0].click();
                    event.target.closest('#select-glue-type').classList.remove('open');
                    this.classList.add('return');
                    this.classList.add('search');
                }
            });
            this.selectors.labelGlueTypeClose.addEventListener('click', event => {
                const options = this.selectors.labelGlueTypeClose.querySelectorAll('.option');
                options.length > 0 && options[0].click();
                event.target.closest('#select-glue-type').classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            });
            this.selectors.labelGlueTypeOptions.addEventListener('click', event => {
                const value = event.target.closest('.option').dataset.value;
                const filtername = event.target.closest('.option').dataset.filtername;
                const index = this.filterBagCache.findIndex(
                    item => item.startsWith(`${filtername}=`)
                )
                if (index !== -1) {
                    this.filterBagCache.splice(index, 1);
                    this.filterBagCache.push(`${filtername}=${value}`);
                } else {
                    this.filterBagCache.push(`${filtername}=${value}`);
                }
                this.selectors.manufactureOptions.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.coreSize.classList.remove('active','open');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelGlueTypeInput.value = event.target.closest('.option').textContent;
                this.emptyResult = false;
                this.fetchCollection('none', this.selectors.labelGlueTypeOptions,this.selectors.labelGlueType);
                this.selectors.labelGlueType.classList.remove('open');
                this.classList.add('search');
                this.classList.add('return');
            })

            this.selectors.rollUp.addEventListener('click', () => {
                if(this.selectors.manufacture.classList.contains('active')) {
                    this.classList.remove('search');
                    this.classList.remove('return');
                    this.selectors.manufactureOptions.classList.add('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.printerModel.classList.contains('active')) {
                    this.selectors.printerModel.classList.remove('active');
                    this.selectors.manufacture.classList.add('active');
                    this.classList.remove('search');
                    this.classList.remove('return');
                    this.selectors.manufactureOptions.classList.add('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.coreSize.classList.contains('active')) {
                    this.selectors.coreSize.classList.remove('active');
                    this.selectors.printerModel.classList.add('active');
                    this.classList.remove('search');
                    this.classList.remove('return');
                    this.selectors.manufactureOptions.classList.remove('active');
                    this.selectors.printerModelOptions.classList.add('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.labelWidth.classList.contains('active')) {
                    this.selectors.labelWidth.classList.remove('active');
                    this.selectors.printerModel.classList.add('active');
                    this.classList.add('search');
                    this.classList.add('return');
                    this.selectors.manufactureOptions.classList.remove('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.add('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.labelHeight.classList.contains('active')) {
                    this.selectors.labelHeight.classList.remove('active');
                    this.selectors.labelWidth.classList.add('active');
                    this.classList.add('search');
                    this.classList.add('return');
                    this.selectors.manufactureOptions.classList.remove('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.add('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.labelMaterial.classList.contains('active')) {
                    this.selectors.labelMaterial.classList.remove('active');
                    this.selectors.labelHeight.classList.add('active');
                    this.classList.add('search');
                    this.classList.add('return');
                    this.selectors.manufactureOptions.classList.remove('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.add('active');
                    this.selectors.labelMaterialOptions.classList.remove('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
                if(this.selectors.labelGlueType.classList.contains('active')) {
                    this.selectors.labelGlueType.classList.remove('active');
                    this.selectors.labelMaterial.classList.add('active');
                    this.classList.add('search');
                    this.classList.add('return');
                    this.selectors.manufactureOptions.classList.remove('active');
                    this.selectors.printerModelOptions.classList.remove('active');
                    this.selectors.coreSizeOptions.classList.remove('active');
                    this.selectors.labelWidthOptions.classList.remove('active');
                    this.selectors.labelHeightOptions.classList.remove('active');
                    this.selectors.labelMaterialOptions.classList.add('active');
                    this.selectors.labelGlueTypeOptions.classList.remove('active');
                }
            })

            this.selectors.rollClose.addEventListener('click', () => {
                this.selectors.printerModel.classList.remove('active');
                this.selectors.printerModelOptions.classList.remove('active');
                this.selectors.coreSize.classList.remove('active');
                this.selectors.coreSizeOptions.classList.remove('active');
                this.selectors.labelGlueType.classList.remove('active');
                this.selectors.labelGlueTypeOptions.classList.remove('active');
                this.selectors.labelMaterial.classList.remove('active');
                this.selectors.labelMaterialOptions.classList.remove('active');
                this.selectors.labelHeight.classList.remove('active');
                this.selectors.labelHeightOptions.classList.remove('active');
                this.selectors.labelWidth.classList.remove('active');
                this.selectors.labelWidthOptions.classList.remove('active');
                this.selectors.manufacture.classList.add('active');
                this.selectors.manufactureOptions.classList.add('active');
                this.selectors.manufacture.selectedIndex = 0;
                this.selectors.gridResult.innerHTML = '';
                this.selectors.gridResult.classList.remove('active');
                this.classList.remove('search');
                this.classList.remove('return');
                this.selectors.summaryFooter.classList.remove('active');
                this.selectors.searchHero.classList.remove('active');
            })
            this.selectors.search.addEventListener('click', () => {
                if(this.selectors.manufacture.classList.contains('active')) {
                    this.selectors.manufacture.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.printerModel.classList.contains('active')) {
                    this.selectors.printerModel.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.coreSize.classList.contains('active')) {
                    this.selectors.coreSize.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.labelWidth.classList.contains('active')) {
                    this.selectors.labelWidth.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.labelHeight.classList.contains('active')) {
                    this.selectors.labelHeight.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.labelMaterial.classList.contains('active')) {
                    this.selectors.labelMaterial.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
                if(this.selectors.labelGlueType.classList.contains('active')) {
                    this.selectors.labelGlueType.classList.add('open');
                    this.classList.add('search');
                    this.classList.remove('return');
                }
            })

            this.initFetch();
        }
        async initFetch() {
            try {
                const filters = await this.fetchManufactureFilter();
                this.selectors.manufactureOptions.innerHTML = '';
                Array.from(filters.manufacture).forEach(filter => {
                    const option = document.createElement('div');
                    option.classList.add('option');
                    option.dataset.value = filter.value;
                    option.dataset.filtername = filter.name;
                    option.textContent = this.toTitleCase(filter.value);
                    this.selectors.manufactureOptions.appendChild(option);
                })

            } catch (err) {
                console.error(err);
            }
        }
        toTitleCase(str) {
            if (!str) return "";

            return str
                .toLowerCase()
                .split(/[\s-]+/)
                .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
                )
                .join(" ");
        }
 
        async fetchManufactureFilter() {
            const manufacture = new Set;
            try {
                const response = await fetch(`/collections/all?section_id=collection-filter`);
                if(!response.ok) {
                    throw new Error(`Preload failed with status ${response.status}`);
                }
                const html = await response.text();
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(html, 'text/html');
                const manufactureFilter = htmlDoc.querySelectorAll('#filter-p-m-custom-printer_manufacturer input.checkbox');
                if(manufactureFilter.length > 0) {
                    manufactureFilter.forEach(filter => {
                        manufacture.add(filter);
                    })
                }                   
            } catch(error) {
                console.error('Preload request failed:', error);
            }
            return {
                manufacture: Array.from(manufacture).sort()
            };
        }
        async fetchCollection(filter,target,container) {
            try {
                    const params = this.filterBagCache
                    .map(param => {
                        const [key, value] = param.split('=');
                        const encodedValue = encodeURIComponent(value).replaceAll(',', '+');
                        return `${key}=${encodedValue}`;
                    })
                    .join('&');
                    const response = await fetch(
                    `/collections/all?section_id=collection-filter&${params}`
                    );

                    if(!response.ok) {
                        throw new Error(`Preload failed with status ${response.status}`);
                    }
                    const html = await response.text();
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(html, 'text/html');
                    const collectionGrid = htmlDoc.querySelector('.product-list--collection');
                    collectionGrid && (this.selectors.gridResult.classList.add('active'));
                    const filterSelected = htmlDoc.querySelector('.collection__filter-checkbox-list .collection__filter-checkbox .checkbox-wrapper input:checked');
                    if(collectionGrid) {
                        this.emptyResult = false;
                        this.selectors.gridResult.innerHTML = collectionGrid.innerHTML;
                        this.selectors.summaryFooter.classList.add('active');
                        this.selectors.selectedFilters.innerHTML = `<span>${filterSelected.dataset.filterCount} products found.</span><a href="/collections/all?${params}">View All</a>`;
                    } else {
                        this.emptyResult = true;
                        const collectionEmpty = htmlDoc.querySelector('.empty-state.empty-state--tight');
                        this.selectors.gridResult.innerHTML = collectionEmpty ? collectionEmpty.innerHTML : '';
                    }
                    if(filter === 'none' || this.emptyResult) {
                        return;
                    }
                    const filterInputs = htmlDoc.querySelectorAll(`#${filter} input.checkbox`);
                    if(filterInputs.length > 0 && !this.emptyResult) {
                        target.innerHTML = '';
                        this.selectors.manufacture.classList.remove('active','open');
                        this.selectors.manufactureInput.value = '';
                        this.selectors.printerModel.classList.remove('active','open');
                        this.selectors.coreSize.classList.remove('active','open');
                        this.selectors.labelWidth.classList.remove('active','open');
                        this.selectors.labelHeight.classList.remove('active','open');
                        this.selectors.labelGlueType.classList.remove('active','open');
                        this.selectors.labelMaterial.classList.remove('active','open');
                        const selectedModels = this.manufacturerHierarchy.filter(manufacturer => manufacturer.manufacturer.toLowerCase() === this.manufacturerSelected.toLowerCase());
                        filterInputs.forEach(input => {
                            if(container.id === 'select-model' && selectedModels.length > 0) {
                                if(selectedModels[0].models.includes(input.value)) {
                                    const option = document.createElement('div');
                                    option.classList.add('option');
                                    option.dataset.value = input.value;
                                    option.dataset.filtername = input.name;
                                    option.textContent = input.value;
                                    target.appendChild(option);
                                }
                            } else {
                                const option = document.createElement('div');
                                option.classList.add('option');
                                option.dataset.value = input.value;
                                option.dataset.filtername = input.name;
                                option.textContent = input.value;
                                target.appendChild(option);
                            }
                        })
                        target.classList.add('active');
                        container.classList.add('active');
                        this.selectors.searchHero.classList.add('active');
                    }                    
            } catch(error) {
                console.error('Preload request failed:', error);
            }
        }
    }
    customElements.define('compatibility-search', CompatibilitySearch);
}